import React, { useEffect, useState } from 'react'
import { Button, Card, Drawer } from 'antd'
import { Timeline } from 'antd';
import { useDispatch } from "react-redux";
import { listAbstractActivityFxn } from "./actions";
import { displayDateWithtime } from '../../components/_utils/appUtils';

const AbstractHistoryDrawer = (props) => {
  const dispatch = useDispatch()
  const { visible, onClose, abstractId } = props;
  const [activities, setActivities] = useState([])

  const loadActivity = async () => {
    if (abstractId) {
      let obj = {
        results: 100,
        count: 100,
        abstractId
      }
      let resp = await dispatch(listAbstractActivityFxn(obj))
      if (resp && resp.data) {
        setActivities(resp.data);
      }
    }
  }

  useEffect(() => {
    if (visible) {
      loadActivity()
    }
  }, [visible, abstractId])

  return (
    <Drawer
      title={"Abstract Activities History"}
      width={'35%'}
      onClose={onClose}
      visible={visible}
      bodyStyle={{ paddingBottom: 80 }}
      footer={
        <div className={'alignRight'}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
        </div>
      }>
      <Card>
        <Timeline>
          {activities && activities.length ? activities.map((item, index) => {
            return (
              <Timeline.Item key={index} className={'timeline-block'}>
                {item.details}
                <br />
                <strong className={'date'}>
                  {displayDateWithtime(item.addedOn || item.createdAt)}
                </strong>
              </Timeline.Item>
            )
          }) : <p>No history found for this abstract.</p>}
        </Timeline>
      </Card>
    </Drawer>
  )
}

export default AbstractHistoryDrawer
